export const validatePassword = (pwd: string) => {
  const isValid =
    /^(?=.*[0-9])(?=.*[*.!@#$%^&(){}])[a-zA-Z0-9*.!@#$%^&(){}]{12,}$/g.test(
      pwd
    );
  return isValid;
};

export const generateRandomPassword = () => {
  const groups = [
    'abcdefghijklmnopqrstuvwxyz',
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    '0123456789',
    '*.!@#$%^&(){}'
  ];
  const symbols = groups.join('');
  const value = new Uint8Array(1);
  // Reject the uneven tail so every character and shuffle position is equally likely.
  const randomIndex = (length: number) => {
    const limit = 256 - (256 % length);
    do {
      crypto.getRandomValues(value);
    } while (value[0] >= limit);
    return value[0] % length;
  };
  // Include each required character group without retrying whole passwords.
  const result = groups.map((group) => group[randomIndex(group.length)]);
  while (result.length < 30) result.push(symbols[randomIndex(symbols.length)]);
  for (let i = result.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result.join('');
};

export const PASSWORD_HELPER_TEXT =
  'Password must have at least 12 characters where there is at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special symbol from *.!@#$%^&(){}';
